<template lang="pug">
.conteudo
    .linha(style='margin: 0px')
        .coluna
            title-component(
                :label='isEditing ? "Editar região " + regiao.nome : "Cadastrar Região de Análise"'
            )

    .linha(style='marginTop: 0px')
        .coluna
            breadcrumb-component(:list='regiaoAnalise')

    .linha
        .coluna
            text-input-component(
                v-model='regiao.nome',
                label='Nome da região*:',
                :touch='validacao.nome'
                placeholder=''
            )
        .coluna-2
            text-input-component(
                v-model='regiao.uf',
                label='UF:',
                :disabled="true",
                placeholder=''
            )
    .linha
        .coluna Município (Região de análise atual)*:

    .linha
        .coluna
            filter-basic-component(
                @filtro:pesquisar='pesquisar($event)',
            )
        .coluna-1
            button-component(:label='isSelectedAll ? "Remover todos" : "Selecionar todos"', icon='mdi-checkbox-marked-outline', @click.native='selecionarTodos')

    .linha
        .coluna(:class='isLoading ? "--loading" : ""')
            #municipios-box(
                :style='[ municipios.length <= 7 ? "" : { columnCount: "3" } ] ',
                :class="[validacao.municipios ? '--error' : '' , isLoading ? '--loading' : '']"
            )
                checkbox-group-input-component(
                    v-model='regiao.municipios',
                    :list='municipios'
                )
    .linha.acoes(:style="{ marginTop : '40px'}")
        button-component(
            background-color='var(--primary-dark-smoke)',
            icon='mdi-close',
            label='Voltar',
            @click.native='voltar'
        )
        button-component(
            icon='mdi-check-circle-outline',
            :label='isEditing ? "Editar" : "Cadastrar"',
            @click.native='confirmaEdicao'
        )
    modal-component(
        v-if='modalEditaRegiao',
        :title='"Deseja realmente cadastrar/editar região?"',
        @close='modalEditaRegiao = false'
    )
        .modal-footer(:style='[ { display: "flex" },  { justifyContent: "space-between" }, { marginTop: "30px" } ]')
            button-component(
                label='Cancelar',
                icon='mdi-close',
                background-color='var(--primary-gray)',
                color='var(--primary-light-smoke)',
                @click.native='modalEditaRegiao = false'
            )
            button-component(label='Confirmar', icon='mdi-check', @click.native='finalizar')
</template>

<script>
import {
    cadastrarRegiao,
    editarRegiao,
    municipios,
    buscarPorId
} from '@/services/regiaoAnalise.service';

import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue';

import { regiaoAnalise } from '@/utils/breadcrumb.utils';

export default {

    name: 'CadastrarRegiaoComponent',

    components: {
        FilterBasicComponent
    },

    data() {
        return {

            regiaoAnalise: regiaoAnalise.cadastro,

            modalEditaRegiao: false,

            isLoading: false,

            regiao: {
                id: null,
                nome: null,
                uf: 'São Paulo',
                padrao: null,
                quantidadeMunicipios: null,
                idsMunicipios: [],
                municipios: []
            },

            municipios: [],

            isEditing: !!this.$route.params.id,

            validacao: {
                nome: false,
                municipios: false
            },

            isSelectedAll: false,

        };
    },

    created() {

        this.isLoading = true;
        Promise.all([
            this.getMunicipios(),
            this.getRegiao(),
        ]).then(([municipios, regiao]) => {
            if (regiao) {
                regiao.municipios = regiao.municipios.map(m => { return { ...m, selecionado: true } });
                this.municipios = [...regiao.municipios, ...municipios];

                regiao.uf = 'São Paulo';

                this.regiao = regiao;
                this.isLoading = false;
                return;

            }
            this.municipios = municipios;
        });
    },

    methods: {

        async getMunicipios() {
            let list = await municipios();
            list.forEach(municipio => {
                municipio.selecionado = false;
            });
            return list;
        },

        getRegiao() {
            if (this.isEditing) {
                let id = this.$route.params.id;
                return buscarPorId(id);
            }
            return null;
        },

        async pesquisar(searchValue) {
            if (searchValue === '') {
                this.municipios = await this.getMunicipios();
                this.regiao.municipios.forEach(mun => {
                    let index = this.municipios.map(m => m.id).indexOf(mun.id);
                    if (index == -1) this.municipios = [mun, ...this.municipios];
                    this.municipios[index] = mun;
                })
            } else {
                let filteredMunicipios = this.municipios.filter(municipio => municipio.nome.toLowerCase().includes(searchValue));
                this.municipios = filteredMunicipios;
            }
        },

        confirmaEdicao() {
            this.modalEditaRegiao = true;
        },

        async finalizar() {

            this.regiao.idsMunicipios = this.regiao.municipios.map(m => m.id);

            if (!this.notValid()) {
                let result;

                if (!this.isEditing) {
                    result = cadastrarRegiao({
                        nome: this.regiao.nome,
                        uf: this.regiao.uf,
                        idsMunicipios: this.regiao.idsMunicipios
                    })
                }
                else {
                    result = editarRegiao({
                        nome: this.regiao.nome,
                        uf: this.regiao.uf,
                        idsMunicipios: this.regiao.idsMunicipios
                    }, this.regiao.id)
                }
                try {
                    await result;
                    this.$toast({
                        showClose: true,
                        message: 'Região cadastrado/editada com sucesso!',
                        type: 'success'
                    });
                    this.$router.push({ name: "regiao" })
                } catch { }

            } else {

                this.$toast({
                    showClose: true,
                    message: 'Erro ao concluir região!',
                    type: 'error'
                });
            }
        },

        notValid() {
            let flag;
            if (!this.regiao.nome || this.regiao.nome === '') {
                this.validacao.nome = true;
                flag = true;
            }
            if (this.regiao.nome) {
                this.validacao.nome = false;
                flag = false;
            }
            if (!this.regiao.municipios || this.regiao.municipios.length === 0) {
                this.validacao.municipios = true;
                flag = true;
            }
            if (this.regiao.municipios.length > 0) {
                this.validacao.municipios = false;
                flag = false;
            }
            return flag;
        },

        voltar() {
            this.$router.push({ name: "regiao" })
        },

        selecionarTodos() {
            this.regiao.municipios = this.municipios.map(m => { return { ...m, selecionado: !this.isSelectedAll } });
            this.municipios = this.regiao.municipios
            this.isSelectedAll = !this.isSelectedAll;
        }
    }
}
</script>

<style lang="scss" scoped>
#municipios-box {
    height: 250px;
    overflow-y: auto;
}

#municipios-box::-webkit-scrollbar {
    width: 8px;
}

#municipios-box::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

#municipios-box::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.acoes {
    display: flex;
    justify-content: space-between;
}

#municipios-box.--error {
    border: 2px solid var(--primary-light-red) !important;
    border-radius: 5px;
}

#municipios-box .--loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-smoke);
    background-image: url('../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
}
</style>
